.container {
  position: sticky;
  top: 0;
  z-index: 30;
}

.messageBlock {
  position: relative;
  background-color: #fca311 !important;
}
